import { apiPost } from './api';
import {
  AuthResponse,
  LoginCredentials,
  SignupCredentials,
  MetaMaskAuthPayload,
} from '../types/auth';

export async function login(credentials: LoginCredentials): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/auth/login', credentials, false);
}

export async function signup(credentials: SignupCredentials): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/auth/signup', credentials, false);
}

export async function loginWithMetaMask(
  payload: MetaMaskAuthPayload,
): Promise<AuthResponse> {
  return apiPost<AuthResponse>('/auth/metamask/verify', payload, false);
}

export function saveToken(token: string): void {
  localStorage.setItem('jwt_token', token);
}

export function clearToken(): void {
  localStorage.removeItem('jwt_token');
}

export function getStoredToken(): string | null {
  return localStorage.getItem('jwt_token');
}
